module.exports = __webpack_public_path__ + "static/media/03.97107e5f.png";